"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPreviewRequestState = exports.getKickbackPreviews = exports.getHasForm = exports.getDynosLastFetchedTimestamp = exports.haveDynosFetchingError = exports.areDynosFetching = exports.getAudienceFilter = exports.getAudience = exports.getType = exports.getLocale = exports.getFormFields = exports.getEditorValidation = exports.getEditableDyno = exports.getDynosEditor = exports.getDynoById = exports.getDynosById = exports.getDynos = void 0;

var _RedirectButtonType = _interopRequireDefault(require("lead-flows-ui/constants/RedirectButtonType"));

var getDynos = function getDynos(state) {
  return Object.values(state.dynos.dynosById || {});
};

exports.getDynos = getDynos;

var getDynosById = function getDynosById(state) {
  return state.dynos.dynosById;
};

exports.getDynosById = getDynosById;

var getDynoById = function getDynoById(state, dynoId) {
  return getDynos(state)[dynoId];
};

exports.getDynoById = getDynoById;

var getDynosEditor = function getDynosEditor(state) {
  return state.dynosEditor;
};

exports.getDynosEditor = getDynosEditor;

var getEditableDyno = function getEditableDyno(state) {
  return state.dynosEditor.editableDyno;
};

exports.getEditableDyno = getEditableDyno;

var getEditorValidation = function getEditorValidation(state) {
  return state.dynosEditor.validation;
};

exports.getEditorValidation = getEditorValidation;

var getFormFields = function getFormFields(state) {
  return getEditableDyno(state).formFields;
};

exports.getFormFields = getFormFields;

var getLocale = function getLocale(state) {
  return getEditableDyno(state).locale;
};

exports.getLocale = getLocale;

var getType = function getType(state) {
  return getEditableDyno(state).type;
};

exports.getType = getType;

var getAudience = function getAudience(state) {
  return getEditableDyno(state).audience;
};

exports.getAudience = getAudience;

var getAudienceFilter = function getAudienceFilter(state) {
  return getAudience(state).filter;
};

exports.getAudienceFilter = getAudienceFilter;

var areDynosFetching = function areDynosFetching(state) {
  return state.dynos.isFetching;
};

exports.areDynosFetching = areDynosFetching;

var haveDynosFetchingError = function haveDynosFetchingError(state) {
  return state.dynos.fetchingHasError;
};

exports.haveDynosFetchingError = haveDynosFetchingError;

var getDynosLastFetchedTimestamp = function getDynosLastFetchedTimestamp(state) {
  return state.dynos.lastFetched;
};

exports.getDynosLastFetchedTimestamp = getDynosLastFetchedTimestamp;

var getHasForm = function getHasForm(state) {
  return typeof getEditableDyno(state).calloutButtonType === 'undefined' || getEditableDyno(state).calloutButtonType === _RedirectButtonType.default.GO_TO_FORM_STEP;
};

exports.getHasForm = getHasForm;

var getKickbackPreviews = function getKickbackPreviews(state) {
  return getEditableDyno(state).kickbackPreviews;
};

exports.getKickbackPreviews = getKickbackPreviews;

var getPreviewRequestState = function getPreviewRequestState(state) {
  return getEditableDyno(state).isFetchingPreviews;
};

exports.getPreviewRequestState = getPreviewRequestState;